import React, { useEffect, useMemo } from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ProviderInput from '../../../../../../../../components/Inputs/ProviderInput';

import * as types from '../../reducer/constants';
import { getNumberValue, getProviderFormService } from '../../helper';
import { getSyncModeMin, getSyncModeMax } from './helper';
import { getProvider } from '../../../../../helpers/getters';

const FieldMinMax = ({ form, providerForm, isLoadingProvider, errorProvider, dispatchServiceData }) => {
  const { provider_id, provider_service_id, auto_min, auto_max, min, max } = form;
  const provider = useMemo(() => getProvider(provider_id), [provider_id]);
  const service = useMemo(() => getProviderFormService(provider_service_id, providerForm), [provider_service_id, providerForm]);
  const syncMin = service ? service.service_min : false;
  const syncMax = service ? service.service_max : false;
  const syncModeMin = useMemo(
    () => getSyncModeMin(provider, service, errorProvider, isLoadingProvider),
    [provider, service, errorProvider, isLoadingProvider],
  );
  const syncModeMax = useMemo(
    () => getSyncModeMax(provider, service, errorProvider, isLoadingProvider),
    [provider, service, errorProvider, isLoadingProvider],
  );

  const onChangeMin = (e) => {
    const value = e.target.value;
    const min = getNumberValue(value);
    if (!_.isBoolean(min)) {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_MIN, value: min });
    }
  };

  const onChangeSyncMin = (value) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_MIN, value });
    /**
     * Если отключаем sync min
     * добавляем значение из sync
     */
    if (!value) {
      const newValue = syncMin || min;
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_MIN, value: newValue || '' });
    }
  };

  const onChangeSyncMax = (value) => {
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_MAX, value });
    /**
     * Если отключаем sync max
     * добавляем значение из sync
     */
    if (!value) {
      const newValue = syncMax || max
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_MAX, value: newValue || '' });
    }
  };

  const onChangeMax = (e) => {
    const value = e.target.value;
    const min = getNumberValue(value);
    if (!_.isBoolean(min)) {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_MAX, value: min });
    }
  };

  /**
   * Если провайдер или сервис отвалился, надо убрать синки
   * Только после первого запуска модалки
   */
  useEffect(() => {
    if (!syncModeMin) {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_MIN, value: false });
    }
    if (!syncModeMax) {
      dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_SYNC_MAX, value: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="row">
      <div className="col-sm-6">
        <FormGroup className="form-group__min">
          <ControlLabel htmlFor="min">Min order</ControlLabel>
          <ProviderInput
            name="min"
            syncMode={syncModeMin}
            syncValue={service && auto_min}
            providerValue={syncMin}
            onChange={onChangeMin}
            onChangeSync={onChangeSyncMin}
            value={min || ''}
          />
        </FormGroup>
      </div>
      <div className="col-sm-6">
        <FormGroup className="form-group__max">
          <ControlLabel htmlFor="max">Max order</ControlLabel>
          <ProviderInput
            name="max"
            syncMode={syncModeMax}
            syncValue={service && auto_max}
            onChange={onChangeMax}
            onChangeSync={onChangeSyncMax}
            providerValue={syncMax}
            value={max || ''}
          />
        </FormGroup>
      </div>
    </div>
  );
};

FieldMinMax.propTypes = {
  form: PropTypes.object,
  providerForm: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isLoadingProvider: PropTypes.bool,
  errorProvider: PropTypes.string,
  dispatchServiceData: PropTypes.func,
}

export default FieldMinMax;
